/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

/**
 * Attach services to Application
 * Services allouw us to register API Resources
 */
require('./services/Tag.js');

/**
 * Require Controllers
 * Controllers hangle JS logic
 */
require('./controllers/TagController.js');
